import { Service } from './';

export abstract class EntityService extends Service {

  static getList(params: any): Promise<any> {
    return this.axios.get(`${this.entity}`, { params }).then(res => res.data);
  }

  static get(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}`).then(res => res.data);
  }

  static getDetail(id: string, params?: any): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/detail`, { params }).then(res => res.data);
  }

  static getCopyInvoice(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/copy-invoice`).then(res => res.data);
  }

  static create(data: any): Promise<any> {
    return this.axios.post(`${this.entity}`, data).then(res => res.data);
  }

  static update(id: string, data: any): Promise<any> {
    return this.axios.put(`${this.entity}/${id}`, data).then(res => res.data);
  }

  static createAcccountSearch(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/account`, data).then(res => res.data);
  }

  static delete(id: string): Promise<any> {
    return this.axios.delete(`${this.entity}/${id}`).then(res => res.data);
  }

  static downloadExcelTemplate(): Promise<any> {
    return this.axios.get(`${this.entity}/excel-template`, { responseType: 'blob' }).then(res => res.data);
  }

  static downloadExcel(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/file-excel`, { params, responseType: 'blob' }).then(res => res.data);
  }

  static uploadExcel(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/upload`, data).then(res => res.data);
  }

}
